<ion-app>
  <div id="main-content" class="wrapper">
    <ion-router-outlet *ngIf="core.auth.isAuthenticated !== null; else loading"></ion-router-outlet>

    <ng-template #loading>
      <ion-content>
        <ion-spinner name="crescent"></ion-spinner>
        <ion-text>Cargando...</ion-text>
      </ion-content>
    </ng-template>
  </div>
</ion-app>
